import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Sobre from "@/components/site/Sobre";
import Servicos from "@/components/site/Servicos";
import Portfolio from "@/components/site/Portfolio";
import Testemunhos from "@/components/site/Testemunhos";
import Contacto from "@/components/site/Contacto";
import Footer from "@/components/site/Footer";

const Home = () => {
  return (
    <div data-testid="home-page" className="relative">
      <Nav />
      <main>
        <Hero />
        <Sobre />
        <Servicos />
        <Portfolio />
        <Testemunhos />
        <Contacto />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
